import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

export function StoreRailBlock({
  label,
  children,
}: {
  readonly label: string;
  readonly children: ReactNode;
}) {
  const headingId = `side-${label.toLowerCase()}`;
  return (
    <section aria-labelledby={headingId} {...stylex.props(styles.block)}>
      <h2 id={headingId} {...stylex.props(styles.title)}>
        {label}
      </h2>
      {children}
    </section>
  );
}

const styles = stylex.create({
  block: { display: "flex", flexDirection: "column", gap: spacing.space12 },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: "18px",
    fontWeight: 400,
    color: colors.subtle,
  },
});
